import {
    ALERTA_OK,
    ALERTA_DISPOSITIVO_CLEAR_OK,
    ALERTA_DISPOSITIVO_ERROR,
    OBTENER_ALERTAS_DISPOSITIVO
} from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case OBTENER_ALERTAS_DISPOSITIVO:
            return {
                ...state,
                alertasDispositivo: action.payload,
            };
            break;
        case ALERTA_OK:
            return {
                ...state,
                mensaje: action.payload,
            };
            break;
        case ALERTA_DISPOSITIVO_CLEAR_OK:
            return {
                ...state,
                mensaje: null,
            };
            break;
        case ALERTA_DISPOSITIVO_ERROR:
            return {
                ...state,
                mensaje: action.payload,
            };
            break;
            
        default:
            return state;
    }
}